<ul class="nav nav-tabs border-0" *ngIf="plan">
  <li class="nav-item">
    <a
      href="javascript:void()"
      class="nav-link border-0"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="active"
      [routerLink]="'/plans/implementation-plan/' + plan.id + '/dashboard'">
      Plan Dashboard
    </a>
  </li>
  <li class="nav-item">
    <a
      href="javascript:void()"
      class="nav-link border-0"
      routerLinkActive="active"
      [routerLink]="'/plans/implementation-plan/' + plan.id + '/details'">
      Plan Details
    </a>
  </li>
  <li *ngIf="planEditor" class="nav-item">
    <a
      href="javascript:void()"
      class="nav-link border-0"
      routerLinkActive="active"
      [routerLink]="'/plans/implementation-plan/' + plan.id + '/sharing'">
      Plan Sharing
    </a>
  </li>
  <li *ngIf="canSeeStatusReports" class="nav-item">
    <a
      href="javascript:void()"
      class="nav-link border-0"
      routerLinkActive="active"
      [routerLink]="
        '/plans/implementation-plan/' + plan.id + '/status-reports'
      ">
      Status Reports
    </a>
  </li>
</ul>
